import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

import { buildWorkbookPreviousSupport } from "../sectionsIndicatorsEntities/exporters/exporterIndicatorPreviousSupport.js";
import { buildWorkbookOpinionIssuer } from "../sectionsIndicatorsEntities/exporters/exporterIndicatorOpinionIssuer.js";
import { buildWorkbookMCESupport } from "../sectionsIndicatorsEntities/exporters/exporterIndicatorMCESupport.js";
import { buildWorkbookComplementary } from "../sectionsIndicatorsEntities/exporters/exporterIndicatorComplementaryActivities.js";

function makeUniqueNamer() {
  const used = new Set();
  return (name) => {
    let base = String(name || "file").trim();
    if (!base) base = "file";
    let out = base;
    let n = 2;
    while (used.has(out)) {
      const dot = out.lastIndexOf(".");
      const ext = dot > -1 ? out.slice(dot) : "";
      const stem = dot > -1 ? out.slice(0, dot) : out;
      out = `${stem} (${n})${ext}`;
      n++;
    }
    used.add(out);
    return out;
  };
}

async function writeWorkbookToZip(zip, filename, wb) {
  const array = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  zip.file(
    filename,
    new Blob([array], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    { compression: "STORE" }
  );
}

const EXCEL_EXPORTERS = [
  {
    id: "apoiosPrevios",
    filename: "apoios_previos.xlsx",
    buildWorkbook: buildWorkbookPreviousSupport,
  },
  {
    id: "emissoraDeParecer",
    filename: "emissora_de_parecer.xlsx",
    buildWorkbook: buildWorkbookOpinionIssuer,
  },
  {
    id: "apoiosMCE",
    filename: "apoios_mce.xlsx",
    buildWorkbook: buildWorkbookMCESupport,
  },
  {
    id: "complementares",
    filename: "atividades_complementares.xlsx",
    buildWorkbook: buildWorkbookComplementary,
  },
];

export async function exportAllEntitiesExcelsZip(
  zipName = "indicadores_entidades_de_acompanhamento_excels.zip",
  progress
) {
  const zip = new JSZip();
  const uniq = makeUniqueNamer();
  let added = 0;

  for (const entry of EXCEL_EXPORTERS || []) {
    if (!entry) continue;
    const { id, filename, buildWorkbook } = entry;

    try {
      if (typeof buildWorkbook === "function") {
        const wb = await buildWorkbook();
        const safeName = uniq(filename || `${id}.xlsx`);
        await writeWorkbookToZip(zip, safeName, wb);
        added++;
        continue;
      }

      zip.file(
        `__faltam_exporters/${id}.txt`,
        `Ainda não existe exporter Excel válido para a secção "${id}".`
      );
    } catch (e) {
      zip.file(
        `__falhas/${id}.txt`,
        `Falha a gerar Excel de "${id}": ${e?.message || e}`
      );
    }
  }

  if (added === 0) {
    zip.file(
      "__info.txt",
      "Nenhum Excel adicionado. Verifique os exporters individuais."
    );
  }

  const out = await zip.generateAsync(
    { type: "blob", compression: "STORE" },
    (metadata) => {
      progress?.onZipProgress?.(metadata.percent || 0, metadata.currentFile);
    }
  );
  saveAs(out, zipName);
}
